import { IAddress } from '../address.model';
import { OrderStatus } from '../enumerations/order-status.model';
import { OrderRestaurant } from './order-restaurant.model';
import { IOrderMenu } from './order-menu.model';
import { ICustomerDTO } from './customer-dto.model';
import { PaymentTypes } from '@/shared/model/enumerations/payment-types.model';

export interface IOrderDetail {
  id?: number | null;
  orderNumber?: number | null;
  orderNumberEnc?: string | null;
  orderDate?: Date | null;
  sumOfBasket?: number | null;
  sumOfMenuCosts?: number | null;
  restaurantId?: number | null;
  customerId?: number | null;
  paymentTypeValue?: PaymentTypes | null;
  deliveryTime?: Date | null;
  preparingTime?: number | null;
  zipcode?: string | null;
  remark?: string | null;
  voucher?: string | null;
  delivery?: boolean | false;
  status?: OrderStatus | null;
  paymentReference?: string | null;
  paymentToken?: string | null;
  orderPaid?: boolean | false;
  payerId?: string | null;
  ratingId?: number | null;
  customer?: ICustomerDTO | null;
  deliverAddress?: IAddress | null;
  restaurant?: OrderRestaurant | null;
  orderMenus?: IOrderMenu[] | null;
  deliveryTimeString?: string | null;
}

export class OrderDetail implements IOrderDetail {
  constructor(
    public id?: number | null,
    public orderNumber?: number | null,
    public orderNumberEnc?: string | null,
    public orderDate?: Date | null,
    public sumOfBasket?: number | null,
    public sumOfMenuCosts?: number | null,
    public restaurantId?: number | null,
    public customerId?: number | null,
    public paymentTypeValue?: PaymentTypes | null,
    public deliveryTime?: Date | null,
    public preparingTime?: number | null,
    public zipcode?: string | null,
    public remark?: string | null,
    public voucher?: string | null,
    public delivery?: boolean | false,
    public status?: OrderStatus | null,
    public paymentReference?: string | null,
    public paymentToken?: string | null,
    public orderPaid?: boolean | false,
    public payerId?: string | null,
    public ratingId?: number | null,
    public customer?: ICustomerDTO | null,
    public deliverAddress?: IAddress | null,
    public restaurant?: OrderRestaurant | null,
    public orderMenus?: IOrderMenu[] | null
  ) {}

  public get deliveryTimeString(): string {
    return this.timeGetterFunc('deliveryTime');
  }
  public set deliveryTimeString(newDeliveryTimeString: string) {
    this.deliveryTime = this.setHoursFunc(newDeliveryTimeString);
  }

  private timeGetterFunc(field: string): string {
    return this[field] ? this.checkTime(this[field].getHours()) + ':' + this.checkTime(this[field].getMinutes()) : '';
  }

  private setHoursFunc(newHour: string): Date {
    const newDate = newHour ? new Date() : null;
    const newHourArray = newHour?.split(':');
    newDate && newDate.setHours(parseInt(newHourArray[0], 10), parseInt(newHourArray[1], 10));
    return newDate;
  }

  private checkTime(time: number): string {
    return time >= 10 ? time.toString() : '0' + time;
  }
}
